import React from 'react';
import { useDragDropContext } from '../contexts/DragDropContext';
import { useTheme } from '../contexts/ThemeContext';

const DragGhost: React.FC = () => {
  // No visual feedback during drag - return null
  return null;
};

export default DragGhost;
